jQuery( function ( $ ) {

  const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  }

  $( '.space-break' ).each( function () {
    const $this = $( this )

    const toggleBreak = ( on ) => {
      $this.toggleClass( 'break', on )
    }

    const breaks = ( $( this ).attr( 'data-break' ) || '' ).split(',').filter( Boolean ).map( x => ({
      bp: breakpoints[ x ] || 0,
      type: 'break',
    }))

    const spaces = ( $( this ).attr( 'data-space' ) || '' ).split(',').filter( Boolean ).map( x => ({
      bp: breakpoints[ x ] || 0,
      type: 'space',
    }))

    const bps = [ ...breaks, ...spaces ].sort( ( a, b ) => a.bp - b.bp )

    bps.forEach( obj => {
      const cb = obj.type == 'break' ? toggleBreak : toggleSpace
      const query = window.matchMedia( `( min-width: ${ obj.bp }px )` )
      const isBreak = obj.type == 'break'
      const shouldBreak = query.matches ? isBreak : !isBreak;
      toggleBreak( shouldBreak )
      query.addEventListener( 'change', e => {
        const shouldBreak = e.matches ? isBreak : !isBreak;
        toggleBreak( shouldBreak )
      })
      
    })
  })

});